import {getTokensByType, replaceAllFiltersByTypeInSearchQuery} from '@github-ui/filter-query'
import {ActionList, ActionMenu} from '@primer/react'
import type {HTMLAttributes, RefObject} from 'react'

import {createQuickFilterAnchor, type QuickFilterProps} from './quick-filter-shared'

const REVIEW_FILTERS = [
  {value: 'none', label: 'No reviews'},
  {value: 'required', label: 'Review required'},
  {value: 'approved', label: 'Approved review'},
  {value: 'changes-requested', label: 'Changes requested'},
] as const

const reviewAnchor = createQuickFilterAnchor('Reviews')

function ReviewAnchor({ref, ...props}: HTMLAttributes<HTMLElement> & {ref?: RefObject<HTMLButtonElement | null>}) {
  return reviewAnchor(props, ref)
}

export function ReviewQuickFilter({query, onQueryChange}: QuickFilterProps) {
  const selectedReview = getTokensByType(query, 'review').at(-1)

  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <ReviewAnchor />
      </ActionMenu.Anchor>
      <ActionMenu.Overlay>
        <ActionList selectionVariant="single">
          {REVIEW_FILTERS.map(({value, label}) => (
            <ActionList.Item
              key={value}
              selected={selectedReview === value}
              onSelect={() => onQueryChange(replaceAllFiltersByTypeInSearchQuery(query, [value], 'review'))}
            >
              {label}
            </ActionList.Item>
          ))}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
